import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';

class ReportsPage extends React.Component {
    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{ReportsPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <span>reports goes here ...</span>
                    </div>
                </div>
            </div>
        );
    }
}

ReportsPage.meta = {
    label: <FormattedMessage id={'reports'} defaultMessage={'Reports'} />,
    icon: 'bar_chart',
    action: () => history.push('/reports'),
    locations: ['/reports']
};

export default ReportsPage;



// WEBPACK FOOTER //
// ./src/pages/reports/index.jsx